<template>
<div id="scene-container" ref="sceneContainer">
    <div id="ui-container" ref="uiContainer">
        <ArtifactDetails ref="artifact" v-bind:iden="itemId" @button="displayModal" />
        <Gate3dMetadata ref="gateMeta" v-bind:gateName="this.$router.currentRoute.name" />
    </div>
</div>
</template>

<script>
import * as THREE from 'three'
import {
    GLTFLoader
} from 'three/examples/jsm/loaders/GLTFLoader'
/* import Stats from 'stats.js' */
import GateElements from "../components/GateElements";
import Gate3dMetadata from "@/components/Gate3dMetadata";
import ArtifactDetails from "../components/ArtifactDetails";
import {
    /*  MeshBasicMaterial,
      PlaneGeometry,
      TextureLoader,
      Mesh,*/
    Vector3,
    AudioLoader,
    Quaternion
} from "three";
import {
    Audio
} from "three/src/audio/Audio";
import {
    AudioListener
} from 'three/src/audio/AudioListener'
import {
    bus
} from "@/main";

export default {
    name: 'Green',
    components: {
        ArtifactDetails,
        Gate3dMetadata
    },
    data() {
        return {
            container: null,
            scene: null,
            camera: null,
            startedInteraction: false,
            controls: null,
            renderer: null,
            /*
                  stats: null,
            */
            modalVisible: false,

            listener: null,
            ambience: [],
            ambiencePath: [
                '/audio/gates/Green/Green_Atmos.mp3',
                '/audio/gates/Green/Green_MusicalLoop.mp3',
            ],
            audioContexts: [],
            biquadFilters: [],
            cutoutPlane: null,
            cutoutTexture: null,
            cameraPos: null,

            itemId: null,


            sceneObjects: [{
                    campfire: {
                        object: null,
                        id: 15,
                    },
                    drum: {
                        object: null,
                        id: 16,
                    },
                    fiddle: {
                        object: null,
                        id: 17,
                    },
                    homeopathy: {
                        object: null,
                        id: 18,
                    },
                    meal_prep: {
                        object: null,
                        id: 19,
                    },
                    tin_whistle: {
                        object: null,
                        id: 20,
                    },
                    paints: {
                        object: null,
                        id: 21,
                    },
                    wash_tree: {
                        object: null,
                        id: 22,
                    },
                    wool: {
                        object: null,
                        id: 23,
                    },
                    songsheet_angry: {
                        object: null,
                        id: 24,
                    },
                    songsheet_witches: {
                        object: null,
                        id: 25,
                    },
                    tree: {
                        object: null,
                        id: 26,
                    },
                    tent: {
                        object: null,
                        id: 27,
                    },
                    wash_tub: {
                        object: null,
                        id: 28,
                    },
                    dreamcatcher: {
                        object: null,
                        id: 29,
                    },
                    sun_green: {
                        object: null,
                        id: 30,
                    },
                }
                ],

                lastTouchPos: null,
                clock: null,
                targetRotation: null,
            }
        },
        methods: {
                async init() {

                    // set container
                    this.container = this.$refs.sceneContainer

                    // clock needed for rotation slerp
                    this.clock = new THREE.Clock()

                    /*      // add stats
                          this.stats = new Stats()
                          this.container.appendChild(this.stats.dom)*/

                    // add camera
                    this.camera = GateElements.createFirstPersonCamera()

                    // create scene
                    this.scene = new THREE.Scene()
                    this.scene.background = new THREE.Color('#9FCAF2')

                    // add lights
                    const ambientLight = new THREE.HemisphereLight(
                        0xffffff, // bright sky color
                        0x222222, // dim ground color
                        1.5 // intensity
                    )
                    const mainLight = new THREE.DirectionalLight(0xffffff, 1.0)
                    mainLight.position.set(5, 1, 5)
                    this.scene.add(ambientLight, mainLight)

                    // add controls
                    this.controls = GateElements.createFirstPersonControls(this.camera, this.container);

                    // create renderer
                    this.renderer = GateElements.createRenderer()
                    this.container.appendChild(this.renderer.domElement)

                    // set the mouse & raycaster
                    this.mouse = new THREE.Vector2()
                    this.raycaster = new THREE.Raycaster();

                    // load and add an object to the scene
                    var sceneObject = await this.loadGeometryAsync()
                    this.scene.add(sceneObject.scene)

                    this.assignObjects()

                    // add the textured cutout cutoutPlane
                    //this.addCutoutPlane()


                    //audio part
                    this.listener = new AudioListener()
                    this.camera.add(this.listener)

                    await this.loadPlayAmbienceAsync(this.ambiencePath[0])
                    await this.loadPlayAmbienceAsync(this.ambiencePath[1])

                    this.prepareFilters(0, 22000)
                    this.prepareFilters(1, 22000)
                },

                render() {
                    this.renderer.render(this.scene, this.camera)
                    /*this.stats.update()*/

                },

                animate() {
                    this.renderer.setAnimationLoop(() => {
                        this.render()
                        if (!this.startedInteraction) this.camera.rotation.y += 0.0005

                    })
                    this.establishListeners()
                },


                stopAnimating() {
                    this.renderer.setAnimationLoop(null);
                },

                establishListeners() {
                    window.addEventListener('resize', this.onWindowResize.bind(this), false)
                    window.addEventListener('mousedown', this.onMouseClick.bind(this), false)

                    window.addEventListener('touchmove', this.onTouchMove.bind(this), false);

                },

                onWindowResize() {
                    // set aspect ratio to match the new browser window aspect ratio
                    this.camera.aspect = window.innerWidth / window.innerHeight;
                    this.camera.updateProjectionMatrix();
                    this.renderer.setSize(window.innerWidth, window.innerHeight);
                    this.controls.handleResize();
                },


                loadPlayAmbienceAsync(trackPath) {
                    let tempAmbience = new Audio(this.listener)
                    this.ambience.push(tempAmbience)
                    return new Promise((resolve) => {
                        const loader = new AudioLoader()
                        loader.load(
                            trackPath,
                            buffer => {
                                tempAmbience.setBuffer(buffer)
                                tempAmbience.setLoop(true)
                                tempAmbience.setVolume(0.5)
                                tempAmbience.play()
                                resolve(buffer)
                            },
                            undefined,
                            undefined
                        )
                    })
                },

                loadGeometryAsync() {
                    return new Promise((resolve) => {
                        const loader = new GLTFLoader()
                        loader.load(
                            '/models/gate_green.glb',
                            model => {
                                //console.log('Green: loading model ' + model)
                                resolve(model)
                            },
                            undefined,
                            undefined
                        )
                    })
                },

              prepareFilters(index, targetValue){
                this.audioContexts.push(this.ambience[index].context)
                this.biquadFilters.push(this.audioContexts[index].createBiquadFilter())
                this.biquadFilters[index].type = "lowpass"
                this.ambience[index].setFilter(this.biquadFilters[index])
                this.biquadFilters[index].frequency.setValueAtTime(targetValue, this.audioContexts[index].currentTime);
              },

                /*

                    addCutoutPlane() {
                      this.cutoutTexture = new TextureLoader().load('/textures/sprite_test.png');
                      const material = new MeshBasicMaterial({
                        map: this.cutoutTexture,
                        alphaTest: 0.5
                      });
                      const geometry = new PlaneGeometry(2, 2, 1);
                      this.cutoutPlane = new Mesh(geometry, material);
                      this.cutoutPlane.position.z = -10;
                      this.cutoutPlane.position.x = -10;
                      this.cutoutPlane.position.y = -10;
                      this.cutoutPlane.castShadow = true;
                      this.cutoutPlane.receiveShadow = false;
                      this.scene.add(this.cutoutPlane);
                      this.pointTowardsCamera(this.cutoutPlane)
                    },
                */

                pointTowardsCamera(objectToLook) {
                    const currentCam = new Vector3(this.camera.position.x, this.camera.position.y, this.camera.position.z)
                    objectToLook.lookAt(currentCam)
                },


                assignObjects() {
                    this.sceneObjects[0].campfire.object = this.scene.getObjectByName('Campfire');
                    this.sceneObjects[0].drum.object = this.scene.getObjectByName('Drum');
                    this.sceneObjects[0].fiddle.object = this.scene.getObjectByName('Fiddle');
                    this.sceneObjects[0].homeopathy.object = this.scene.getObjectByName('Homeopathy');
                    this.sceneObjects[0].meal_prep.object = this.scene.getObjectByName('Meal_Prep');
                    this.sceneObjects[0].tin_whistle.object = this.scene.getObjectByName('Tin_Whistle');
                    this.sceneObjects[0].paints.object = this.scene.getObjectByName('Paints');
                    this.sceneObjects[0].wash_tree.object = this.scene.getObjectByName('Wash_Tree');
                    this.sceneObjects[0].wool.object = this.scene.getObjectByName('Wool');
                    this.sceneObjects[0].songsheet_angry.object = this.scene.getObjectByName('Songsheet_Angry');
                    this.sceneObjects[0].songsheet_witches.object = this.scene.getObjectByName('Songsheet_Witches');
                    this.sceneObjects[0].tree.object = this.scene.getObjectByName('Tree');
                    this.sceneObjects[0].tent.object = this.scene.getObjectByName('Tent');
                    this.sceneObjects[0].wash_tub.object = this.scene.getObjectByName('Wash_Tub');
                    this.sceneObjects[0].dreamcatcher.object = this.scene.getObjectByName('Dreamcatcher');
                    this.sceneObjects[0].sun_green.object = this.scene.getObjectByName('Sun_Green');
                },

                onTouchMove(event) {
                    const delta = this.clock.getDelta();
                    const step = 3 * delta
                    if (event.touches[0].clientX > this.lastTouchPos) {
                        this.targetRotation = this.camera.rotation.y += 0.035
                    } else {
                        this.targetRotation = this.camera.rotation.y -= 0.035
                    }
                    if (this.camera.rotation.y !== this.targetRotation) {

                        let newRot = new Quaternion(this.camera.rotation.x, this.camera.rotation.y, this.camera.rotation.z)
                        this.camera.quaternion.slerp(newRot, step)
                    }
                    this.lastTouchPos = event.touches[0].clientX
                },


                onMouseClick(event) {
                    if (!this.startedInteraction) this.startedInteraction = true

                    if (this.modalVisible) return
                    this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
                    this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
                    this.raycaster.setFromCamera(this.mouse, this.camera);
                    let intersects = this.raycaster.intersectObjects(this.scene.children, true);

                    if (intersects.length > 0) {
                        {
                            switch (intersects[0].object) {
                                case this.sceneObjects[0].campfire.object:
                                    this.itemId = this.sceneObjects[0].campfire.id
                                    this.displayModal();
                                    break;
                                case this.sceneObjects[0].drum.object:
                                    this.itemId = this.sceneObjects[0].drum.id
                                    this.displayModal();
                                    break;
                                case this.sceneObjects[0].fiddle.object:
                                    this.itemId = this.sceneObjects[0].fiddle.id
                                    this.displayModal();
                                    break;
                                case this.sceneObjects[0].homeopathy.object:
                                    this.itemId = this.sceneObjects[0].homeopathy.id
                                    this.displayModal();
                                    break;
                                case this.sceneObjects[0].meal_prep.object:
                                    this.itemId = this.sceneObjects[0].meal_prep.id
                                    this.displayModal();
                                    break;
                                case this.sceneObjects[0].tin_whistle.object:
                                    this.itemId = this.sceneObjects[0].tin_whistle.id
                                    this.displayModal();
                                    break;
                                case this.sceneObjects[0].paints.object:
                                    this.itemId = this.sceneObjects[0].paints.id
                                    this.displayModal();
                                    break;
                                case this.sceneObjects[0].wash_tree.object:
                                    this.itemId = this.sceneObjects[0].wash_tree.id
                                    this.displayModal();
                                    break;
                                case this.sceneObjects[0].wool.object:
                                    this.itemId = this.sceneObjects[0].wool.id
                                    this.displayModal();
                                    break;
                                case this.sceneObjects[0].songsheet_angry.object:
                                    this.itemId = this.sceneObjects[0].songsheet_angry.id
                                    this.displayModal();
                                    break;
                                case this.sceneObjects[0].songsheet_witches.object:
                                    this.itemId = this.sceneObjects[0].songsheet_witches.id
                                    this.displayModal();
                                    break;
                                case this.sceneObjects[0].tree.object:
                                    this.itemId = this.sceneObjects[0].tree.id
                                    this.displayModal();
                                    break;
                                case this.sceneObjects[0].tent.object:
                                    this.itemId = this.sceneObjects[0].tent.id
                                    this.displayModal();
                                    break;
                                case this.sceneObjects[0].wash_tub.object:
                                    this.itemId = this.sceneObjects[0].wash_tub.id
                                    this.displayModal();
                                    break;
                                case this.sceneObjects[0].dreamcatcher.object:
                                    this.itemId = this.sceneObjects[0].dreamcatcher.id
                                    this.displayModal();
                                    break;
                                case this.sceneObjects[0].sun_green.object:
                                    this.itemId = this.sceneObjects[0].sun_green.id
                                    this.displayModal();
                                    break;
                                default:
                                    break;
                            }
                        }
                    }
                },

                displayModal() {
                    this.$refs.artifact.toggleVisibility(this.itemId)
                    setTimeout(this.revolveModal.bind(this), 150)

                },

                revolveModal() {
                    this.modalVisible = !this.modalVisible

                  if (!this.modalVisible){
                    this.biquadFilters[0].frequency.setValueAtTime(22000, this.audioContexts[0].currentTime);
                    this.biquadFilters[1].frequency.setValueAtTime(22000, this.audioContexts[1].currentTime);
                    for (let i = 0; i < this.ambience.length; i++) {
                      this.ambience[i].setVolume(1.0)
                    }
                  }
                  else{
                    this.biquadFilters[0].frequency.setValueAtTime(800, this.audioContexts[1].currentTime);
                    this.biquadFilters[0].frequency.setValueAtTime(800, this.audioContexts[1].currentTime);
                    for (let i = 0; i < this.ambience.length; i++) {
                      this.ambience[i].setVolume(0.5)
                    }
                  }

                },

                disableController(valueReceived) {
                    this.controls.isThreeDimensionOnly(valueReceived)
                },
            },
            computed: {
                collectables() {
                    return this.$store.getters.collectables;
                }
            },

            mounted() {
                this.init().then(() => this.animate())
            },

            created() {
                bus.$on('sliderOff', this.disableController);
            },

            beforeDestroy() {
                bus.$off('sliderOff');
                this.stopAnimating()
                for (let i = 0; i < this.ambience.length; i++) {
                    this.ambience[i].pause()
                }
            },
    }
</script>

<style scoped>
#scene-container {
    height: 100%;
    overflow: hidden;
    z-index: 96;
}

#ui-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 97;
    /* pointer-events: auto; */
}
</style>
